import { __extends } from "tslib";
import { ASObject, axCoerceString } from '@awayfl/avm2';
var TextRenderer = /** @class */ (function (_super) {
    __extends(TextRenderer, _super);
    function TextRenderer() {
        var _this = _super.call(this) || this;
        console.warn('[TextRenderer] not implemented');
        return _this;
    }
    Object.defineProperty(TextRenderer.prototype, "antiAliasType", {
        // static _antiAliasType: string;
        // static _maxLevel: number /*int*/;
        // static _displayMode: string;
        get: function () {
            console.warn('[TextRenderer] - get antiAliasType not implemented');
            return null;
        },
        set: function (value) {
            value = axCoerceString(value);
            console.warn('[TextRenderer] - set antiAliasType not implemented');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextRenderer.prototype, "maxLevel", {
        get: function () {
            console.warn('[TextRenderer] - get maxLevel not implemented');
            return 0;
        },
        set: function (value /*int*/) {
            value = value | 0;
            console.warn('[TextRenderer] - set maxLevel not implemented');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextRenderer.prototype, "displayMode", {
        get: function () {
            console.warn('[TextRenderer] - get displayMode not implemented');
            return null;
        },
        set: function (value) {
            value = axCoerceString(value);
            console.warn('[TextRenderer] - set displayMode not implemented');
        },
        enumerable: true,
        configurable: true
    });
    TextRenderer.setAdvancedAntiAliasingTable = function (fontName, fontStyle, colorType, advancedAntiAliasingTable) {
        fontName = axCoerceString(fontName);
        fontStyle = axCoerceString(fontStyle);
        colorType = axCoerceString(colorType);
    };
    // Called whenever the class is initialized.
    TextRenderer.classInitializer = null;
    // List of static symbols to link.
    TextRenderer.classSymbols = null; // [];
    // List of instance symbols to link.
    TextRenderer.instanceSymbols = null; // [];
    return TextRenderer;
}(ASObject));
export { TextRenderer };
